/**
 * EducationDashboardScreen
 *
 * Dedicated dashboard for tenants subscribed to the Education ERP suite.
 * Widgets will be added here once the user shares the exact widget specifications.
 * This shell already wires up the correct page title and layout container
 * so Education-only users land on a clean, purpose-built canvas.
 */
export default function EducationDashboardScreen() {
  return (
    <div className="bridge-canvas flex flex-col gap-6">
      {/* ── Page Header ─────────────────────────────────────────────── */}
      <section className="flex flex-col gap-1">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-on-surface">
          Dashboard
        </h1>
        <p className="text-xs text-on-surface-variant">
          Education ERP — real-time campus overview.
        </p>
      </section>

      {/* ── Widgets ─────────────────────────────────────────────────── */}
      {/* TODO: Add Education Dashboard widgets here once spec is shared */}
      <div className="flex items-center justify-center rounded-2xl border border-dashed border-outline-variant py-20 text-on-surface-variant">
        <div className="flex flex-col items-center gap-3 text-center">
          <span className="material-symbols-outlined text-5xl">school</span>
          <p className="text-sm font-semibold">Education Dashboard</p>
          <p className="text-xs opacity-60 max-w-xs">
            Widgets will appear here. Share the widget specifications to proceed.
          </p>
        </div>
      </div>
    </div>
  )
}
